import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

const DeleteUser = () => {
  const BASE_URI = process.env.REACT_APP_API_URL;
//   console.log(BASE_URI, "apirul");
  const [formdata, setformdata] = useState({
    mobileNo: "",
    email: "",
  });
  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformdata((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear errors when user types
    if (name === "mobileNo") setPhoneError("");
    if (name === "email") setEmailError("");
  };

  const handleSubmit = async () => {
    let isValid = true;

    // Validate Phone Number (10 digits)
    if (!/^\d{10}$/.test(formdata.mobileNo)) {
      setPhoneError("Phone number must be exactly 10 digits.");
      isValid = false;
    }

    // Validate Email (Regex)
    if (!/^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formdata.email)) {
      setEmailError("Invalid email format.");
      isValid = false;
    }

    if (!isValid) return;

    try {
      const data = {
        mobile_number: formdata.mobileNo,
        email: formdata.email,
      };
      const config = { headers: { "Content-Type": "application/json" } };
      const response = await axios.post(
        `https://apic.myreview.website:8445/api/deactivate_account_email`,
        data,
        config
      );
      toast.success(
        response?.data?.message || "Account deactivated successfully!"
      );

      setformdata({
        mobileNo: "",
        email: "",
      });
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "An error occurred"
      );
    }
  };

  return (
    <div className="bg-[#ffffff] border-box w-full h-fit">
      <div className="w-full h-fit px-3 pb-12 flex flex-col items-center gap-8 mt-[100px]">
        <p className="text-[#6540b2] text-2xl font-bold mb-4 max-w-[1200px] text-center">
          Delete user account we pay wallet.
        </p>
        <div className="w-[500px] h-fit bg-[#d1c7ecc2] rounded-xl p-2 sm-p-6 flex flex-col items-center gap-5 border border-gray-50">
          <div className="w-[110px] h-[110px]">
            <img
              src={require("../../assets/logo/WePeWallet.png")}
              className="w-full h-full object-fill"
            />
          </div>
          <p className="text-[13px] text-[#350f86]">
            Please Enter Your Details
          </p>

          {/* Phone Number */}
          <div className="w-full sm:w-[95%] flex flex-col items-end gap-1">
            <input
              className="w-full h-[2.5rem] border-[.5px] border-[#bbbbbb] rounded-md outline-none px-2 placeholder:text-[14px] placeholder:text-[#878292]"
              placeholder="Enter Phone No"
              name="mobileNo"
              type="text"
              value={formdata.mobileNo}
              onChange={handleChange}
            />
            {phoneError && (
              <p className="text-[#fd5757] text-[13px]">{phoneError}</p>
            )}
          </div>

          {/* Email */}
          <div className="w-full sm:w-[95%] flex flex-col items-end gap-1">
            <input
              className="w-full h-[2.5rem] border-[.5px] border-[#bbbbbb] rounded-md outline-none px-2 placeholder:text-[14px] placeholder:text-[#878292]"
              placeholder="Enter Email"
              name="email"
              type="text"
              value={formdata.email}
              onChange={handleChange}
            />
            {emailError && (
              <p className="text-[#fd5757] text-[13px]">{emailError}</p>
            )}
          </div>

          {/* Submit Button */}
          <div className="w-full p-2 mt-4 flex flex-col justify-center items-center gap-3 mb-8">
            <button
              className="w-full py-2 rounded-md bg-gradient-to-r from-[#6540b2] via-[#876ac7] to-[#6540b2] text-white font-bold ease-in duration-[0.4s] hover:scale-[0.9]"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteUser;
